import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';

import { ColorCodesEnum } from '../../enums';
import {Helper} from '../../classes/helpers';

@Component({
  selector: 'app-slide-toggle',
  templateUrl: Helper.getPortalTemplate(),
  styleUrls: [Helper.getPortalStyle()]
})
export class SlideToggleComponent {
  @Input() checked: boolean;
  @Input() color: string;
  @Input() disabled: boolean;
  @Input() texts: [string, string];

  @Output() public changed: EventEmitter<boolean>;

  constructor() {
    // @ts-ignore
    if (!this.checked) {
      this.checked = false;
    }

    // @ts-ignore
    if (!this.color) {
      this.color = ColorCodesEnum.Primary;
    }

    // @ts-ignore
    if (!this.disabled) {
      this.disabled = false;
    }

    // @ts-ignore
    if (!this.texts) {
      this.texts = ['', ''];
    }

    this.changed = new EventEmitter<boolean>();
  }

  onSlideToggleChange(event: MatSlideToggleChange): void {
    this.changed.emit(event.checked);
  }
}
